import React, { useEffect, useState } from "react";
import "./Profile.css";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/userSlice";
import { useParams } from "react-router-dom";
import { child, onValue, ref, set } from "firebase/database";
import { db } from "../../../firebaseConfig";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import SendIcon from "@mui/icons-material/Send";
import PersonIcon from "@mui/icons-material/Person";
import { Fade, Zoom } from "react-reveal";

const { v4: uuidv4 } = require("uuid");

export default function Profile() {
  const { uid } = useParams();
  const user = useSelector(selectUser);

  const [userData, setUserData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Subscribe to real-time updates
    const starCountRef = ref(db, "users");
    const unsubscribe = onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        Object.values(data).forEach((item) => {
          if (item.uid === uid) {
            setUserData(item);
          }
        });
      }
    });
    // Cleanup the subscription on component unmount
    return () => {
      unsubscribe();
    };
  }, [uid]);

  // const todayDate = new Date();
  // const todayDateString = todayDate.toDateString();

  const [quote, setQuote] = useState("");

  useEffect(() => {
    const quoteList = [
      "No matter what looms ahead, if you can eat today, enjoy the sunlight today, mix good cheer with friends today, enjoy it and bless God for it.",
      "Don't Create Content to gain Followers, create it to solve people's problems first.",
      "Free is 10x more enticing than a Discount. It's Fun to do the Impossible.",
      "Give value with 0 expectations, and you'll get 10x results in the long run.",
      "Stop searching for your Purpose, Find Purpose in everything you do",
      "The Biggest Growth Secret is Stopover learning and Start Practicing",
      "Never Sacrifice your reputation for Money",
      "Sell the Transformation, not the Product",
      "Creativity is seeing what others see and thinking what no one else ever thought.",
      "Art is the elimination of the unnecessary. - Pablo Picasso",
      "God, our Creator, has stored within our minds and personalities, great potential strength and ability.",
    ];
    // Get a random index within the range of the quoteList
    const randomIndex = Math.floor(Math.random() * quoteList?.length);

    // Set the random quote based on the random index
    setQuote(quoteList[randomIndex]);
  }, []);

  const [userAge, setUserAge] = useState(userData.userAge || "");
  const [userPhoneNumber, setUserPhoneNumber] = useState(
    userData.userPhoneNumber || ""
  );
  const [maritalStatus, setMaritalStatus] = useState(
    userData.maritalStatus || ""
  );
  const [kinName, setKinName] = useState(userData.kinName || "");
  const [kinPhoneNumber, setKinPhoneNumber] = useState(
    userData.kinPhoneNumber || ""
  );
  const [kinRelationship, setKinRelationship] = useState(
    userData.kinRelationship || ""
  );

  const [isUploading, setIsUploading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const handleClientData = async () => {
    if (
      userAge.length > 0 &&
      userPhoneNumber.length > 0 &&
      maritalStatus.length > 0 &&
      kinName.length > 0 &&
      kinPhoneNumber.length > 0 &&
      kinRelationship.length > 0
    ) {
      try {
        // Update display name in Firebase Realtime Database
        const userRef = ref(db, `users/${uid}`);
        const userAgeRef = child(userRef, "userAge");
        await set(userAgeRef, userAge);

        const userPhoneNumberRef = child(userRef, "userPhoneNumber");
        await set(userPhoneNumberRef, userPhoneNumber);

        const maritalStatusRef = child(userRef, "maritalStatus");
        await set(maritalStatusRef, maritalStatus);

        const kinNameRef = child(userRef, "kinName");
        await set(kinNameRef, kinName);

        const kinPhoneNumberRef = child(userRef, "kinPhoneNumber");
        await set(kinPhoneNumberRef, kinPhoneNumber);

        const kinRelationshipRef = child(userRef, "kinRelationship");
        await set(kinRelationshipRef, kinRelationship);

        setIsUploading(false);
        setIsEdit(false);

        console.log("saved");
      } catch (error) {
        // Handle the error, e.g., log it or show an error message to the user?.
        alert("Oops, a problem occurred");
        console.error("Error updating name:", error);
      }
    } else {
      alert("You must fill all inputs");
    }
  };

  const [noteText, setNoteText] = useState("");

  const [notesData, setNotesData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Subscribe to real-time updates
    const starCountRef = ref(db, `notes/${uid}`);
    const unsubscribe = onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setNotesData(data);
      }
    });
    // Cleanup the subscription on component unmount
    return () => {
      unsubscribe();
    };
  }, [uid]);

  const [notesList, setNotesList] = useState([]);

  const onSendNote = async () => {
    try {
      const notesRef = ref(db, `notes/${uid}`);

      onValue(notesRef, (snapshot) => {
        const updatedData = snapshot.val() || [];
        setNotesList(updatedData);
      });

      // Generate a UUID
      const uuid = uuidv4();
      let updatedData = [
        ...notesList,
        {
          authorID: user?.uid,
          authorPhotoURL: user?.photoURL,
          authorName: user?.displayName,
          authorEmail: user?.email,
          clientEmail: userData.email,
          clientName: userData?.displayName,
          clientDP: user?.photoURL,
          noteID: uuid,
          noteText: noteText,
          noteIndex: notesList.length,
        },
      ];
      // Update the 'comments' field in the database
      await set(notesRef, updatedData);
      setNoteText("");
    } catch (error) {
      // Handle the error, e.g., log it or show an error message to the user?.
      alert("Oops, a problem occurred");
      console.error("Error updating comment:", error);
    }
  };

  const [isClientPhotoLoad, setIsClientPhotoLoad] = useState(false);
  const [isAuthourPhotoLoad, setIsAuthourPhotoLoad] = useState(false);

  return (
    <>
      <div className="profile">
        <div className="profile-larger-container">
          <Zoom>
            <div className="profile-container">
              <div className="profile-top">
                <div>
                  {userData?.photoURL && isClientPhotoLoad ? (
                    <img
                      className="img"
                      src={userData?.photoURL}
                      alt={`${userData?.displayName}`}
                      onLoad={() => setIsClientPhotoLoad(true)}
                    />
                  ) : (
                    <div className="img">
                      <PersonIcon />
                    </div>
                  )}
                  <p>Greetings,</p>
                  <h2>{userData.displayName}</h2>
                </div>
                <button
                  onClick={() => setIsEdit((current) => (current = !current))}
                >
                  <BorderColorIcon className="bio-icon" />
                </button>
              </div>
              <div className="vt-line"></div>
              <div className="client-bio-data">
                <div className="bio-detail">
                  <div className="bio-detail-title">
                    <h2>Age:</h2>
                    {/* {userData?.userAge && (
                    <button
                      onClick={() =>
                        setIsEdit((current) => (current = !current))
                      }
                    >
                      <BorderColorIcon className="bio-icon" />
                    </button>
                  )} */}
                  </div>

                  {isEdit && (
                    <input
                      placeholder="Age"
                      type={"number"}
                      value={userAge}
                      onChange={(e) => setUserAge(e.target.value)}
                    />
                  )}
                  <p className="filled-info">{userData?.userAge || ""}</p>
                </div>
                <div className="bio-detail">
                  <div className="bio-detail-title">
                    <h2>Phone Number:</h2>
                    {/* {userData?.userPhoneNumber && (
                    <button
                      onClick={() =>
                        setIsEdit((current) => (current = !current))
                      }
                    >
                      <BorderColorIcon className="bio-icon" />
                    </button> 
                  )}*/}
                  </div>
                  {isEdit && (
                    <input
                      placeholder="Phone Number"
                      type={"text"}
                      value={userPhoneNumber}
                      onChange={(e) => setUserPhoneNumber(e.target.value)}
                    />
                  )}
                  <p className="filled-info">
                    {userData?.userPhoneNumber || ""}
                  </p>
                </div>
                <div className="bio-detail">
                  <div className="bio-detail-title">
                    <h2>Maritual status:</h2>
                    {/* {userData?.maritalStatus && (
                    <button
                      onClick={() =>
                        setIsEdit((current) => (current = !current))
                      }
                    >
                      <BorderColorIcon className="bio-icon" />
                    </button>
                  )} */}
                  </div>
                  {isEdit && (
                    <input
                      placeholder="maritual status"
                      type={"text"}
                      value={maritalStatus}
                      onChange={(e) => setMaritalStatus(e.target.value)}
                    />
                  )}
                  <p className="filled-info">{userData?.maritalStatus || ""}</p>
                </div>
              </div>
              <div className="kin-bio-data">
                <div className="bio-detail">
                  <div className="bio-detail-title">
                    <h2>Emergency contact name:</h2>
                    {/* {userData?.kinName && ( */}

                    {/* )} */}
                  </div>
                  {isEdit && (
                    <input
                      placeholder="Name"
                      type={"text"}
                      value={kinName}
                      onChange={(e) => setKinName(e.target.value)}
                    />
                  )}
                  <p className="filled-info">{userData?.kinName || ""}</p>
                </div>
                <div className="bio-detail">
                  <div className="bio-detail-title">
                    <h2>Emergency contact:</h2>
                    {/* {userData?.kinAge && (
                    <button
                      onClick={() =>
                        setIsEdit((current) => (current = !current))
                      }
                    >
                      <BorderColorIcon className="bio-icon" />
                    </button>
                  )} */}
                  </div>
                  {isEdit && (
                    <input
                      placeholder="contact"
                      type={"text"}
                      value={kinPhoneNumber}
                      onChange={(e) => setKinPhoneNumber(e.target.value)}
                    />
                  )}
                  <p className="filled-info">
                    {userData?.kinPhoneNumber || ""}
                  </p>
                </div>
                <div className="bio-detail">
                  <div className="bio-detail-title">
                    <h2>Relationship:</h2>
                    {/* {userData?.kinRelationship && (
                    <button
                      onClick={() =>
                        setIsEdit((current) => (current = !current))
                      }
                    >
                      <BorderColorIcon className="bio-icon" />
                    </button>
                  )} */}
                  </div>
                  {isEdit && (
                    <input
                      placeholder="Relationship"
                      type={"text"}
                      value={kinRelationship}
                      onChange={(e) => setKinRelationship(e.target.value)}
                    />
                  )}
                  <p className="filled-info">
                    {userData?.kinRelationship || ""}
                  </p>
                </div>
              </div>
            </div>
          </Zoom>
          <Fade down>
            <button
              onClick={() => handleClientData()}
              disabled={isUploading}
              className="update-btn"
            >
              {isUploading ? "Updating.." : "Update"}
            </button>
          </Fade>
          <Fade up>
            <h2 className="quote">"{quote}"</h2>
          </Fade>
        </div>

        <Fade right>
          <div className="notes-div">
            <div className="note-header">
              <h2>NOTES</h2>
            </div>
            <div className="notes-container">
              {notesData.length !== 0 ? (
                notesData.map(({ noteText, authorPhotoURL }) => (
                  <div className="note-box">
                    {console.log(authorPhotoURL)}

                    {authorPhotoURL && isAuthourPhotoLoad ? (
                      <img
                        src={authorPhotoURL}
                        alt={`${authorPhotoURL}`}
                        onLoad={() => setIsAuthourPhotoLoad(true)}
                      />
                    ) : (
                      <PersonIcon className="person-icon" />
                    )}
                    <p>{noteText}</p>
                  </div>
                ))
              ) : (
                <h3 className="no-notes-text">Your notes will appear here!!</h3>
              )}
              <div className="input-div">
                <input
                  value={noteText}
                  onChange={(e) => setNoteText(e.target.value)}
                  placeholder="Type your note"
                />
                <div className="note-send-btn" onClick={() => onSendNote()}>
                  <SendIcon style={{ color: "#d3d3d3" }} />
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    </>
  );
}
